var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcViewEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-view-eye_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.312 6.774C12.247 4.46 9.84 2.125 6.862 2.125c-2.98 0-5.387 2.335-6.452 4.649a.55.55 0 0 0 0 .452c1.065 2.314 3.472 4.649 6.451 4.649 2.98 0 5.386-2.335 6.45-4.649a.55.55 0 0 0 0-.452m-6.45 4.018c-2.39 0-4.413-1.924-5.358-3.792.945-1.868 2.968-3.792 5.357-3.792S11.274 5.132 12.218 7c-.944 1.868-2.968 3.792-5.357 3.792"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.862 4.29a2.708 2.708 0 1 0 0 5.416 2.708 2.708 0 0 0 0-5.417m0 4.332a1.625 1.625 0 1 1 0-3.25 1.625 1.625 0 0 1 0 3.25"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-view-eye_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.361.5h13v13h-13z"
})))));
export default SvgIcViewEye;